import UAParser from 'ua-parser-js';
import { makeSafeFn, } from 'utils/fn';
import { registerUtils, } from 'application/nm';
import { queryString, } from 'utils/window';
import { canonicalUrl, } from 'application/pageDataObject';
import { create as makeEmptyObj, } from 'utils/object';

let parser = new UAParser();
parser.setUA(navigator.userAgent);
let parserResult = parser.getResult();

// based on domain elevation
function domainFromFqdn(){
  return document.domain.split('.')[0] || '90min';
}

function domainWithTldFromFqdn(){
  return document.domain || '90min.com';
}

const PAGE_LAYOUTS = {
  EMBED: {
    PATH: 'embed',
    INDEXES: [0, 1, ],
  },
  HYBRID: {
    PATH: 'hybrid',
    INDEXES: [0, 1, ],
  },
  NATIVE: {
    PATH: 'native',
    INDEXES: [0, 1, ],
  },
  DRAFT: {
    PATH: 'drafts',
    INDEXES: [0, 1, ],
  },
  TEST: {
    PATH: 'test',
    INDEXES: [0, ],
  },
};

const USER_AGENTS = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  IOS: 'iOS',
  ANDROID: 'Android',
};

const PLATFORMS = {
  DESKTOP: 'desktop',
  MOBILE_WEB: 'mobile web',
  NATIVE_APP: 'native app',
};

const DEVICE_MODELS = {
  NEXUS_6: 'Nexus 6',
};

const BROWSER_NAMES = {
  CHROME: 'Chrome',
  SAFARI: 'Safari',
};

const BROWSER_PN_SUPORTIVE_VERSIONS = {
  CHROME: 42,
};

function isPageLayoutByName(pathnameParts, layout){
  let indexOfLayoutName = pathnameParts.indexOf(layout.PATH);
  return makeSafeFn(function getLayoutName(){
    return layout && layout.INDEXES.includes(indexOfLayoutName) || false;
  }).invoke();
}

function addScreenCoverElementAndReturnHeight() {
  const coverElementId = 'cover-element';
  const element = document.getElementById(coverElementId);
  if (!element) {
    const coverElement = document.createElement('div');
    coverElement.id = coverElementId;
    Object.assign(coverElement.style, {
      position: 'absolute',
      'z-index': '-9999',
      height: '100vh',
      width: '100vw',
      top: '0',
      right: '0',
      left: '0',
      bottom: '0',
    });
    document.body.append && document.body.append(coverElement) || document.body.appendChild(coverElement);
    return document.getElementById(coverElementId).clientHeight;
  }
  return element.clientHeight;
}

const w = window;
const s = screen;
const BREAKPOINTS = {
  TABLET: {
    LANDSCAPE: 1e3,
    PORTRAIT: 768,
  },
};

let userAgent = {

  // TODO: should be united with SASS breakpoint values
  BREAKPOINTS,

  PLATFORMS,

  DEVICE_MODELS,

  BROWSER_NAMES,

  viewport: {
    // add comment about shy we userd the following:
    get width() { return 'orientation' in s ? w.innerWidth : document.body.scrollWidth; },
    get height() { return 'orientation' in s ? w.innerHeight : addScreenCoverElementAndReturnHeight(); },
    get isPortrait() { return this.height > this.width; },
    get orientation() { return this.isPortrait ? 'portrait' : 'landscape'; },
    get widerThanTabletBreakpoint() { return this.width >= BREAKPOINTS.TABLET.LANDSCAPE; },
    get narrowrThanTabletBreakpoint() { return this.width <= BREAKPOINTS.TABLET.LANDSCAPE; },
  },
  get domainFromFqdn() {
    return domainFromFqdn();
  },
  get domainWithTldFromFqdn() {
    return domainWithTldFromFqdn();
  },
  canonicalUrl,
  get isTabletSize() { return this.viewport.width >= BREAKPOINTS.TABLET.LANDSCAPE || this.viewport.height >= BREAKPOINTS.TABLET.LANDSCAPE; },
  get isDesktop() { return this.device.type === undefined && !this.isMobileOs; },
  get isMobile(){
    return this.device.type === USER_AGENTS.MOBILE || !this.isTabletSize && this.isMobileOs;
  },
  get isTablet(){
    return this.device.type === USER_AGENTS.TABLET || this.isTabletSize && this.isMobileOs;
  },
  get isTabletInPortrait() {
    return this.isTablet && this.viewport.isPortrait;
  },
  get isMobileOrTablet() { return this.isMobile || this.isTablet; },
  get isAndroid() { return this.os.name === USER_AGENTS.ANDROID; },
  get isIos() { return this.os.name === USER_AGENTS.IOS; },
  get isBot() { return !!this.ua.match(/bot/i); },
  get isMobileOs() { return this.isIos || this.isAndroid; },
  get browserClassName() {
    return parserResult.browser.name
      .toLowerCase()
      .split(' ')
      .join('-');
  },

  get isSafari(){
    return parserResult.browser.name === BROWSER_NAMES.SAFARI
  },

  get isIe(){
    return parserResult.browser.name === 'IE';
  },

  get isFacebookApp(){
    return /FBAV\/([\w\.]+);/i.test(navigator.userAgent);
  },

  get doesSupportPns(){
    return parserResult.browser.name === BROWSER_NAMES.CHROME && parseInt(parserResult.browser.major, 10) >= BROWSER_PN_SUPORTIVE_VERSIONS.CHROME;
  },

  get platform(){
    return this.isDesktop ? PLATFORMS.DESKTOP : this.isNativeApp ? PLATFORMS.NATIVE_APP : PLATFORMS.MOBILE_WEB;
  },

  get formFactor(){
    return this.isDesktop ? PLATFORMS.DESKTOP : this.isTablet ? USER_AGENTS.TABLET : USER_AGENTS.MOBILE;
  },


  // This can be determined by the post layout, but then we have a problem of backwards compatibility.
  get isNativeApp() { return !!queryString.app || this.path.isNative || this.path.isHybrid; },
  isInIframe: (function detectIframe(){
    try {
      return w.self !== w.top;
    } catch (ex) {
      return true;
    }
  }()),
  path: makeEmptyObj({
    get parts(){
      return w.location.pathname.substr(1).split('/');
    },
    isLayoutByName(layout){
      return isPageLayoutByName(this.parts, layout);
    },
    get isEmbedded(){
      return this.isLayoutByName(PAGE_LAYOUTS.EMBED);
    },
    get isHybrid(){
      return this.isLayoutByName(PAGE_LAYOUTS.HYBRID);
    },
    get isNative(){
      return this.isLayoutByName(PAGE_LAYOUTS.NATIVE);
    },
    get isDraft(){
      return this.isLayoutByName(PAGE_LAYOUTS.DRAFT);
    },
    get isKitchenSink(){
      return this.isLayoutByName(PAGE_LAYOUTS.KITCHEN_SINK);
    },
    get isFullLayout(){
      return !this.isEmbedded && !userAgent.isNativeApp;
    },
  }),
};

Object.assign(userAgent, parserResult, {
  isPlatform: function(platform){
    if (platform === 'desktop') {
      return this.isDesktop;
    }
    if (platform === 'mobile') {
      return this.isMobile;
    }
    return this.device.type === platform;
  }.bind(userAgent),
});

registerUtils({ userAgent, });

export default userAgent;



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/utils/ua.js